import React from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import Iframe from 'react-iframe';
import { withStyles } from '@material-ui/styles';

const styles = {
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
  },
  reactPlayer: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
};

function IframeEmbed(props) {
  const { data, classes } = props;
  return (
    <Container maxWidth="xl">
      <div className={classes.playerWrapper}>
        <Iframe
          url={data.url.embed_url}
          width="100%"
          height="100%"
          className={classes.reactPlayer}
          display="initial"
        />
      </div>
    </Container>
  );
}

IframeEmbed.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IframeEmbed);
